import { render } from "./InsertMultiple.vue?vue&type=template&id=1d35206e&scoped=true"
import script from "./InsertMultiple.vue?vue&type=script&lang=js"
export * from "./InsertMultiple.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./InsertMultiple.vue?vue&type=style&index=1&id=1d35206e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d35206e"]])

export default __exports__